import http from 'utils/http';
import {
  getBusinessLanguageAccentsUrl,
  getBusinessVoiceCreationUrl,
  getBusinessVoicesUrl,
  getBusinessVoiceUrl
} from './apiUrls';
import { VoiceResponse } from './types';

export function getBusinessVoices(
  workspaceId?: string,
  agentId?: string,
  params?: any
): Promise<{ data: VoiceResponse }> {
  return http.get(getBusinessVoicesUrl(workspaceId, agentId), params);
}

export function getBusinessVoice(
  id?: string,
  workspaceId?: string,
  agentId?: string
): Promise<{ data: VoiceResponse }> {
  return http.get(getBusinessVoiceUrl(id, workspaceId, agentId));
}

export function getBusinessLanguageAccents(
  code?: string,
  workspaceId?: string,
  agentId?: string
): Promise<{ data: string[] }> {
  return http.get(getBusinessLanguageAccentsUrl(code, workspaceId, agentId));
}

export function createVoice(workspaceId?: string, agentId?: string, payload?: FormData): Promise<VoiceResponse> {
  return http.post(getBusinessVoiceCreationUrl(workspaceId, agentId), payload);
}
